export const coloursNames = {
  deepSkyBlue: "#009DD6",
  deepSkyBlueDisabled: "#91DBF6",
  cobaltBlue: "#0055B8",
  darkBlue: "#007ba8",
  disabledTableGrey: "#EAECF2",
  disabledSelectGrey: "#f1f1f1",
  brightRed: "#C6301E",
  supernovaYellow: "#FBB034",
  darkOrange: "#b95905",
  cinnabarOrange: '#E64B38',
  highlightBlue: "#78c3f3",
  brightBlue: "#E5F7FD",
  pigmentGreen: "#00B259",
  darkGreen: "#028257",
  lightPurple: "#e5e0ee",
  veryLightPink: "#FDEDEC",
  mediumPurple: "#d2ccd7",
  navyDark: "#00008B",
  studioPurple: "#74489D",
  lightGrey: "#BCBEC0",
  midGrey: "#696969",
  darkGrey: "#414042",
  paleGrey: "#EDF9FE",
  lightDisabled: "#83daf2",
  bgGray: "#f8f9fb",
  panelGray: "#EEEFF1",
  mercury: "#E6E6E6",
  lightGray: "#E3E3E3",
  veryLightGrey: "#F0F1F7",
  darkRed: "#a32035",
  whiteout: "#fbfbfb",
  white: "#fff",
  blue: "#0056ba",
  black: '#212121',
  lightGrey15: 'rgba(188, 190, 192, 0.15)',
  lightGrey30: 'rgba(188, 190, 192, 0.3)',
  lightGrey1: 'rgba(246, 247, 249, 1)',
};

export const colours = {
  primaryText: coloursNames.darkGrey,
  secondaryText: coloursNames.midGrey,
  brightText: coloursNames.whiteout,
  tertiaryText: coloursNames.lightGrey,
  primary: coloursNames.cobaltBlue,
  secondary: coloursNames.deepSkyBlue,
  secondaryDisabled: coloursNames.deepSkyBlueDisabled,
  tertiary: coloursNames.darkBlue,
  warning: coloursNames.supernovaYellow,
  highlight: coloursNames.brightRed,
  link: coloursNames.darkBlue,
  error: coloursNames.brightRed,
  errorBackground: coloursNames.veryLightPink,
  linkErr: coloursNames.lightDisabled,
  success: coloursNames.pigmentGreen,
  inform: coloursNames.studioPurple,
  secundaryInform: coloursNames.mediumPurple,
  tertiaryInform: coloursNames.lightPurple,
  background: coloursNames.bgGray,
  panelBackground: coloursNames.panelGray,
  blueishBg: coloursNames.paleGrey,
  blueBackground: coloursNames.brightBlue,
  highlighter: coloursNames.highlightBlue,
  border: coloursNames.lightGray,
  lightBorder: coloursNames.veryLightGrey,
  unresponsive: coloursNames.darkRed,
  white: coloursNames.white,
  disableTableRow: coloursNames.lightGray,
  disableSelect: coloursNames.disabledSelectGrey,
  disableIcon: coloursNames.lightGrey,
  tabIndex: coloursNames.navyDark,
  verificationPassed: coloursNames.blue,
};
export const inputHeight = {
  normal: 50,
  short: 30,
};

export const input = {
  width: "100%",
  fontSize: "15px",
  height: 50,
  borderRadius: "3px",
  padding: "16px",
  border: `1px solid ${colours.tertiaryText}`,
  outline: 0,
};
